import React from 'react';

import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { yupResolver } from '@hookform/resolvers/yup';
import Input from 'common-ui/input';
import Modal from 'common-ui/modal';
import { selectUserInfo } from 'features/auth/authSlice';
import { saveErpCredentials } from 'features/myAppointments/MyAppointmentsActions';
import { selectErpCredentialsLoading } from 'features/myAppointments/MyAppointmentsSlice';
import * as Yup from 'yup';

import {
  ButtonRow,
  CancelButton,
  FieldsWrapper,
  SubmitButton,
} from './ErpCredentialsModal.styles';

const schema = Yup.object().shape({
  erpLogin: Yup.string().required('ERP login is required'),
  erpPassword: Yup.string().required('ERP password is required'),
});

const ErpCredentialsModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useSelector(selectUserInfo);
  const loading = useSelector(selectErpCredentialsLoading);

  const { control, handleSubmit } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      erpLogin: '',
      erpPassword: '',
    },
  });

  const onSubmit = (data) => {
    const name = [userInfo?.name, userInfo?.surname].filter(Boolean).join(' ');
    dispatch(
      saveErpCredentials({
        uuid: userInfo?.uuid,
        name,
        email: userInfo?.email,
        userType: userInfo?.userType,
        erpLogin: data.erpLogin,
        erpPassword: data.erpPassword,
      })
    )
      .unwrap()
      .then(() => onClose())
      .catch(() => {});
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      title="ERP Credentials"
      footer={false}
      width="420px"
    >
      <FieldsWrapper>
        <Controller
          name="erpLogin"
          control={control}
          render={({ field, fieldState }) => (
            <Input
              {...field}
              label="ERP Login"
              required
              placeholder="Enter your ERP login"
              error={fieldState.error?.message}
              autoComplete="off"
            />
          )}
        />
        <Controller
          name="erpPassword"
          control={control}
          render={({ field, fieldState }) => (
            <Input
              {...field}
              label="ERP Password"
              type="password"
              required
              placeholder="Enter your ERP password"
              error={fieldState.error?.message}
              autoComplete="new-password"
            />
          )}
        />
      </FieldsWrapper>

      <ButtonRow>
        <CancelButton type="button" onClick={() => navigate(-1)}>
          Cancel
        </CancelButton>
        <SubmitButton type="button" onClick={handleSubmit(onSubmit)} disabled={loading}>
          {loading ? 'Saving...' : 'Submit'}
        </SubmitButton>
      </ButtonRow>
    </Modal>
  );
};

export default ErpCredentialsModal;
